import { useEffect } from 'react';
import { Navigate, Routes, Route, Outlet } from 'react-router-dom';

import { RequireAuth, useAuth } from './auth';
import { MainLayout } from './layouts';

import { BetaBanner } from './components/Banners';
import { Home } from './components/Home';
import { About } from './components/About';
import { Policy } from './components/Policies';
import { Memberships } from './components/Memberships';
import { Calendar } from './components/Calendar';
import { FAQList } from './components/FAQ';
import { Reservations, EditReservation } from './components/Reservations';
import { Application } from './components/Application';
import { Contact } from './components/Contact';
import { Directions } from './components/Directions/Directions';
import { ChangePassword } from './components/ChangePassword';

import { setChoiceSignout } from './api/choice/choiceService';
import { PrivacyAgreement } from './components/PrivacyAgreement';

import './App.css';
import './form.scss'

export const SITE_KEY = '6Le02mojAAAAACPL8fzAzIKbT4CwtyevzrQhYZhZ';


export function App (){
    const { signout } = useAuth();
    setChoiceSignout(signout);

    useEffect(() => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();

            return (script);
        }

        // load the script by passing the URL
        /*const element =*/ loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
            console.log("scripts ready");
        });
    }, []);    

    return(
        <div>
            <Routes>
                <Route element={<BetaBanner />}>
                    <Route index element={<Home />} />
                    <Route path='/' element={<MainLayout />} >
                        <Route path='auth' element={<div />} />
                        <Route path='about' element={<About />} />
                        <Route path='policy' element={<Policy />} />
                        <Route path='memberships' element={<Outlet />} >
                            <Route index element={<Memberships />} />
                            <Route path=':defaultType' element={<Memberships />} />
                        </Route>
                        <Route path='event-calendar' element={<Calendar />} />
                        <Route path='member' element={<RequireAuth />}>
                            <Route path='info' element={<p>member info</p>} />
                            <Route path='directions' element={<Directions />} />
                            <Route path='reservation' element={<Reservations />}>
                                <Route path=':eventId' element={<EditReservation />} />
                            </Route>
                            <Route path='setting/password' element={<ChangePassword />} />
                        </Route>
                        <Route path='faq' element={<FAQList />} />
                        <Route path='join' element={<Application />} />
                        <Route path='contact-us' element={<Contact />} />
                        <Route path='*' element={<Navigate to="/" replace={true} />} />
                    </Route>
                </Route>
            </Routes>

            <PrivacyAgreement />
        </div>
    );
}
